import { useCallback, useState, useEffect } from 'react';

import { useDispatch } from 'react-redux'; // Para o dispatch
import { selectComponent, clearSelectedComponent } from '../../../../store/reducers/actions';

import * as DataListAPI from '../../../../api/dataList';
import * as VerificadoresAPI from '../../../../api/verificadores';
import * as ProdutoAPI from '../../../../api/produto';
/* utils */
import { formatarNumeroDecimal } from '../../../../utils/masks';
import { fileToAsset, revokeAsset, revokeAssets } from '../boot/fileAssets';
//helpers
import { findExactOptionByDescricao } from '../../../../helpers/selectUtils';
const { ok, created, warning, info, fail } = require('../../../../helpers/response');

export function useBensModule({
    dados,
    setDados,
    tipo,
    setFlashMessage,
    navigate,
    urlParams,
    mrt,
    OptionsCores,
    EnumBemTipo,
    EnumPosicao,
    empresaId,
    empresaTabelaId,
}) {
    const dispatch = useDispatch();
    const baseItem = {
        descricao: '',
        valor: 0,
        dataCompra: '',
        ambienteId: null,
        ncmId: null,
        Ambiente: {},
        NCM: {},
        ativo: true,
        imagens: [],
        nfs: [],
        funcao: 'Adicionar',
        index: null,
    };

    // --- ESTADOS ---
    const [novoItem, setNovoItem] = useState(baseItem);
    const [previews, setPreviews] = useState({ imagens: [], nfs: [] });

    // Datalists (Padronizados com 'Options')
    const [optionsUF, setUF] = useState([]);
    const [optionsMunicipios, setMunicipio] = useState([]);
    const [OptionsAmbiente, setOptionsAmbiente] = useState([]);
    const [Ambiente, setAmbiente] = useState({});
    const [OptionsNCMInv, setOptionsNCMInv] = useState([]);
    const [NCM, setNCM] = useState({});
    const [Proprietario, setProprietario] = useState({});
    const [OptionsProprietario, setOptionsProprietario] = useState([]);
    const [Modelo, setModelo] = useState({});
    const [OptionsModelo, setOptionsModelo] = useState([]);

    const isOnline = !!dados?.id && !!dados?.produtoBens?.id;

    const isTipoViatura = tipo?.toLowerCase() === 'vtr';
    const isTipoImovel = tipo?.toLowerCase() === 'imovel';

    const filtrarEnumBemTipo = useCallback(
        (lista = []) => {
            if (!Array.isArray(lista)) return [];

            if (isTipoViatura) {
                return lista.filter((item) => {
                    const value = item?.value ?? item?.id ?? item;
                    const label = item?.label ?? item?.descricao ?? item?.name ?? item;

                    return (
                        String(value).toLowerCase() !== 'imovel' &&
                        String(value).toLowerCase() !== 'imóvel' &&
                        String(label).toLowerCase() !== 'imóvel' &&
                        String(label).toLowerCase() !== 'imovel'
                    );
                });
            }

            if (isTipoImovel) {
                return lista.filter((item) => {
                    const value = item?.value ?? item?.id ?? item;
                    const label = item?.label ?? item?.descricao ?? item?.name ?? item;

                    return (
                        String(value).toLowerCase() !== 'movel' &&
                        String(value).toLowerCase() !== 'móvel' &&
                        String(label).toLowerCase() !== 'móvel' &&
                        String(label).toLowerCase() !== 'movel'
                    );
                });
            }

            return lista;
        },
        [isTipoViatura, isTipoImovel]
    );

    const EnumBemTipoFiltrado = filtrarEnumBemTipo(EnumBemTipo);

    // Sincroniza labels ao carregar dados existentes (Edit)
    const consultaUF = async () => {
        const uf = await VerificadoresAPI.uf('');
        setUF(uf);
    };
    const consultaMUNICIPIO = async (ufId, uf, descricao = null) => {
        const result = await VerificadoresAPI.municipio(ufId, uf, descricao);
        setMunicipio(result);
    };

    useEffect(() => {
        consultaUF();
    }, []);
    useEffect(() => {
        if (dados?.produtoBens) {
            setProprietario(dados.produtoBens.Proprietario || {});
            setModelo(dados.produtoBens.produtoModelo || {});
        }
    }, [dados?.produtoBens]);
    useEffect(() => {
        consultaUF();
    }, []);
    useEffect(() => {
        const ufId = dados?.produtoBens?.ufId ?? null;
        ufId && consultaMUNICIPIO(ufId);
    }, [dados?.produtoBens?.ufId]);

    // --- HELPERS ---
    const getIdByValueDom = (value) => {
        return document.querySelector(`datalist option[value="${value}"]`)?.dataset.id || null;
    };
    function onInvImagesChange(e) {
        const files = Array.from(e.target.files || []);
        setNovoItem((prev) => ({ ...prev, imagens: files }));
    }

    function onInvNfsChange(e) {
        const files = Array.from(e.target.files || []);
        setNovoItem((prev) => ({ ...prev, nfs: files }));
    }
    // --- ACTIONS ---
    const refresh = useCallback(async () => {
        if (!dados?.id) return; // só online

        try {
            mrt?.setIsError?.(false);
            mrt?.setIsRefetching?.(true);

            const obj = {
                start: mrt.pagination.pageIndex * mrt.pagination.pageSize,
                size: mrt.pagination.pageSize,
                filters: JSON.stringify(mrt.columnFilters ?? []),
                filtersMode: JSON.stringify(mrt.columnFilterFns ?? {}), // ✅ ESSENCIAL
                globalFilter: mrt.globalFilter ?? '',
                sorting: JSON.stringify(mrt.sorting ?? []),
                produtoBensId: dados?.produtoBens?.id,
            };

            const response = await ProdutoAPI.listarInventario(obj);

            const rows = response?.data?.data ?? [];
            const total = response?.data?.meta?.totalRowCount ?? rows.length;

            setDados((prev) => ({
                ...prev,
                produtoBens: {
                    ...(prev.produtoBens || {}),
                    produtoBensInventarios: rows,
                },
            }));

            mrt?.setRowCount?.(total);
        } catch (e) {
            console.error(e);
            mrt?.setIsError?.(true);
            setFlashMessage?.('Erro ao carregar inventário.', 'error');
        } finally {
            mrt?.setIsRefetching?.(false);
        }
    }, [dados?.id, dados?.produtoBens?.id, mrt, setDados, setFlashMessage]);
    const handleCepBlur = async (e) => {
        const cep = e.target.value?.replace(/\D/g, '');

        if (cep?.length !== 8) return;
        const res = await VerificadoresAPI.cep(cep);

        setDados((prev) => ({
            ...prev,
            produtoBens: {
                ...(prev.produtoBens || {}),
                ufId: res?.ufId,
                municipioId: res?.municipioId,
                bairro: res?.neighborhood?.toUpperCase(),
                logradouro: res?.street?.toUpperCase(),
            },
        }));
    };
    const handlePBDescricaoFocus = async (e) => {
        const btnText = urlParams.get('btnText');
        if (btnText.toLowerCase() !== 'cadastrar') return;
        setDados((prev) => ({
            ...prev,
            produtoBens: { ...(prev.produtoBens || {}), descricao: dados.descricao },
        }));
    };
    const confirmNcmSelection = useCallback(() => {
        const typed = novoItem?.NCM?.descricao || '';
        const exact = findExactOptionByDescricao({ options: OptionsNCMInv, typedValue: typed });

        setNovoItem((prev) => ({
            ...prev,
            ncmId: exact?.id ?? null,
        }));

        // opcional: se não for match exato, avisa
        if (!exact && typed) {
            setFlashMessage?.('Selecione um NCM da lista (clique na sugestão).', 'warning');
        }
    }, [novoItem?.NCM?.descricao, OptionsNCMInv, setFlashMessage]);

    const cleanNovoItem = () => {
        setNovoItem(baseItem);
        setNCM({});
        setAmbiente({});
    };

    /**
     * Handle único para anexos do draft do Inventário.
     * key deve ser: "draftImagens" | "draftNfs"
     */
    const handleDraftFileChange = (e, key) => {
        const pickedFiles = Array.from(e.target.files || []);
        if (!pickedFiles.length) return;

        const extra = key === 'draftImagens' ? { posicao: 'Padrão' } : {};

        const novosAssets = pickedFiles.map((f) => fileToAsset(f, extra));

        setNovoItem((prev) => ({
            ...prev,

            // ✅ UI/preview: continua guardando assets
            //[key]: [...(prev[key] || []), ...novosAssets],
            // ✅ em vez de acumular:
            [key]: novosAssets,
            // ✅ UPLOAD: guarda File[] em chaves separadas (estáveis)
            ...(key === 'draftImagens' ? { imagens: [...(prev.imagens || []), ...pickedFiles] } : {}),
            ...(key === 'draftNfs' ? { nfs: [...(prev.nfs || []), ...pickedFiles] } : {}),
        }));

        e.target.value = '';
    };
    const removeDraftAsset = (key, tempId) => {
        setNovoItem((prev) => {
            const list = prev[key] || [];
            const found = list.find((x) => x.tempId === tempId);

            // importantíssimo: revogar a URL blob quando remover
            revokeAsset(found);

            return {
                ...prev,
                [key]: list.filter((x) => x.tempId !== tempId),
            };
        });
    };
    const clearDraftFiles = () => {
        setNovoItem((prev) => {
            // revoga TODAS as urls blob
            revokeAssets(prev.draftImagens);
            revokeAssets(prev.draftNfs);

            return {
                ...prev,
                draftImagens: [],
                draftNfs: [],
            };
        });
    };

    // Ação para Reaproveitar NF (conforme sua lógica de Redux e Navegação)
    const handleReaproveitarArquivoNF = useCallback(
        (table) => {
            dispatch(clearSelectedComponent());
            const uuids = table.getSelectedRowModel().flatRows.map((row) => row.id);
            dispatch(selectComponent(uuids));

            navigate('/Imovel/EditarNF', {
                ul: urlParams.get('ul'),
                li: urlParams.get('li'),
                tipo: urlParams.get('tipo'),
                uuid: dados.uuid, // UUID do produto pai
            });
        },
        [dispatch, navigate, dados.uuid, urlParams]
    );

    // Ação de Imprimir (já integrada com seus filtros atuais)
    const handleImprimirInventario = useCallback(async () => {
        const params = new URLSearchParams({
            start: `${mrt.pagination.pageIndex * mrt.pagination.pageSize}`,
            size: `${mrt.pagination.pageSize}`,
            filtersMode: JSON.stringify(mrt.columnFilterFns ?? []),
            filters: JSON.stringify(mrt.columnFilters ?? []),
            globalFilter: mrt.globalFilter ?? '',
            sorting: JSON.stringify(mrt.sorting ?? []),
        });

        const response = await ProdutoAPI.inventario(params, dados);
        const pdfUrl = URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
        window.open(pdfUrl);
    }, [mrt, dados]);

    const salvarItem = useCallback(async () => {
        // ------------------------
        // 1) Validações mínimas (UI)
        // ------------------------
        if (!novoItem.descricao) {
            setFlashMessage?.('Descrição é obrigatória', 'error');
            return;
        }

        // (opcional, mas recomendado) evita roundtrip inútil pro backend
        if (!novoItem.ambienteId) {
            setFlashMessage?.('Selecione um Ambiente', 'warning');
            return;
        }

        // Considera "online" quando o produto já existe no banco
        // e o produtoBens também já foi criado no banco.
        const isOnline = !!dados?.id && !!dados?.produtoBens?.id;

        // ------------------------
        // 2) OFFLINE: só mexe no draft (sem API)
        // ------------------------
        if (!isOnline) {
            setDados((prev) => {
                const pb = prev.produtoBens || {};
                const lista = [...(pb.produtoBensInventarios || [])];

                // payload que vai para o draft
                const payload = {
                    ...novoItem,
                    funcao: undefined, // não persiste funcao no draft
                    tempId: novoItem.tempId || Date.now(), // id local para o MRT não quebrar
                };

                if (novoItem.funcao === 'Editar' && Number.isInteger(novoItem.index)) {
                    lista[novoItem.index] = payload;
                } else {
                    lista.push(payload);
                }

                return { ...prev, produtoBens: { ...pb, produtoBensInventarios: lista } };
            });

            // limpa o draft do modal/form
            cleanNovoItem();
            setPreviews({ imagens: [], nfs: [] });
            return;
        }

        // ------------------------
        // 3) ONLINE: envia FormData (dados + arquivos) para /produto/mobilia
        // ------------------------
        try {
            // flags de UI do MRT (pro progress bar)
            mrt?.setIsError?.(false);
            mrt?.setIsRefetching?.(true);

            // monta FormData conforme o controller mobilia espera (req.body + req.files)
            const fd = new FormData();

            fd.append('produtoBensId', String(dados.produtoBens.id));
            fd.append('ambienteId', String(novoItem.ambienteId));
            fd.append('descricao', String(novoItem.descricao || ''));
            fd.append('valor', String(novoItem.valor || 0));
            fd.append('ativo', String(!!novoItem.ativo));

            // backend usa funcao.toLowerCase() === "adicionar"/"editar"
            fd.append('funcao', String(novoItem.funcao || 'Adicionar'));

            if (novoItem.dataCompra) fd.append('dataCompra', String(novoItem.dataCompra));
            if (novoItem.ncmId) fd.append('ncmId', String(novoItem.ncmId));
            if (novoItem.cotacaoId) fd.append('cotacaoId', String(novoItem.cotacaoId));

            // no editar precisa mandar uuid do item
            if (
                (novoItem.funcao || '').toLowerCase() === 'editar' ||
                ((novoItem.funcao || '').toLowerCase() === 'deletar' && novoItem.uuid)
            ) {
                fd.append('uuid', String(novoItem.uuid));
            }

            // upload.any(): pode mandar imagens e PDFs no mesmo campo.
            // Seu controller separa pelo mimetype (pdf vai para NFs, imagem vai para Imagens).
            for (const f of novoItem.imagens || []) fd.append('files', f);
            for (const f of novoItem.nfs || []) fd.append('files', f);

            // IMPORTANTE:
            // Depois do helper no backend, a resposta deve vir assim:
            // { type, message, code, resultado, meta }
            const resp = await ProdutoAPI.mobilia(fd);

            // ------------------------
            // 4) Tratamento do envelope padrão
            // ------------------------

            // Duplicidade (regra de negócio): backend manda type=info + code=DUPLICATE + resultado=row
            if (resp?.code === 'DUPLICATE' && resp?.resultado) {
                setFlashMessage?.(resp.message || 'Item já existe — carregado para edição.', resp.type || 'info');

                // coloca em modo edição, mas zera arquivos pendentes (não “mistura” com o que veio do banco)
                setNovoItem({
                    ...resp.resultado,
                    funcao: 'Editar',
                    index: null, // online não usa index; usa uuid
                    imagens: [],
                    nfs: [],
                });

                setPreviews({ imagens: [], nfs: [] });

                // opcional: refresh para garantir includes (imagens/nfs) atualizados
                // await refresh();

                return;
            }

            // Se veio warning/info/error: mostra e interrompe
            // (ex: validação do backend, ou algum aviso de regra)
            if (resp?.type && resp.type !== 'success') {
                setFlashMessage?.(resp.message || 'Aviso', resp.type);
                return;
            }

            // Sucesso normal
            setFlashMessage?.(resp?.message || 'Salvo.', resp?.type || 'success');

            // limpa o form do item + previews locais
            setNovoItem(baseItem);
            setPreviews({ imagens: [], nfs: [] });

            // Recarrega a grid para refletir:
            // - item criado/editado
            // - anexos gravados (PDF/imagens)
            await refresh();
        } catch (e) {
            console.error(e);
            mrt?.setIsError?.(true);
            setFlashMessage?.('Erro ao salvar item do inventário.', 'error');
        } finally {
            mrt?.setIsRefetching?.(false);
        }
    }, [novoItem, dados?.id, dados?.produtoBens?.id, setDados, baseItem, refresh, mrt, setFlashMessage]);

    const change = useCallback(
        async (e) => {
            const { name, value, type, checked } = e.target;
            const v = type === 'checkbox' ? !!checked : value;

            // 1. Inventário / Mobília (Draft)
            if (name.startsWith('inventario.')) {
                const field = name.replace('inventario.', '');

                // 🔥 DATALISTs
                if (field === 'NCM.descricao') {
                    let selectedId = null;
                    setNCM((prev) => ({ ...prev, descricao: v }));
                    const res = await DataListAPI.dataList({
                        empresaId: empresaTabelaId,
                        tabela: 'NCM',
                        filtro: v,
                    });

                    setOptionsNCMInv(res || []);

                    selectedId = getIdByValueDom(v);

                    selectedId &&
                        setNovoItem((prev) => ({
                            ...prev,
                            ncmId: selectedId,
                        }));

                    return;
                }

                if (field === 'Ambiente.descricao') {
                    let selectedId = null;
                    setAmbiente((prev) => ({ ...prev, descricao: v }));
                    const res = await DataListAPI.dataList({ empresaId, tabela: 'Ambiente', filtro: v });

                    setOptionsAmbiente(res || []);
                    selectedId = getIdByValueDom(v);
                    selectedId && setNovoItem((prev) => ({ ...prev, ambienteId: selectedId, Ambiente: { descricao: v } }));
                    return;
                }

                // fallback: grava no dados se quiser (opcional)
                // campos numericos
                const numberFields = ['valor'];

                if (numberFields.includes(field)) {
                    const valorFormatado = formatarNumeroDecimal(v);

                    setNovoItem((prev) => {
                        const next = { ...prev, [field]: valorFormatado };
                        return { ...next };
                    });
                    return;
                }

                setNovoItem((prev) => ({ ...prev, [field]: v }));
                return;
            }

            // 2. Proprietário (DataList)
            if (name === 'Proprietario.descricao') {
                let selectedId = null;
                setProprietario({ descricao: v });
                const res = await await DataListAPI.dataListParceiroImovel(empresaId, v, true, null, null, null);
                setOptionsProprietario(res || []);
                selectedId = getIdByValueDom(v);

                selectedId &&
                    setDados((prev) => ({
                        ...prev,
                        produtoBens: {
                            ...(prev.produtoBens || {}),
                            proprietarioId: selectedId ?? null,
                            Proprietario: selectedId ? { descricao: v } : prev.produtoBens?.Proprietario,
                        },
                    }));
                return;
            }

            // 3. Modelo (DataList VTR) - Filtrado pelo Fabricante do Produto
            if (name === 'produtoModelo.descricao') {
                let selectedId = null;
                setModelo({ descricao: v });
                const res = await DataListAPI.dataList({
                    empresaId,
                    tabela: 'produtoModelo',
                    condicao: dados.fabricanteId, // Regra de negócio
                    filtro: v,
                });
                setOptionsModelo(res || []);
                selectedId = getIdByValueDom(v);
                selectedId &&
                    setDados((prev) => ({
                        ...prev,
                        produtoBens: {
                            ...(prev.produtoBens || {}),
                            modeloId: selectedId ?? null,
                            produtoModelo: selectedId ? { descricao: v } : prev.produtoBens?.produtoModelo,
                        },
                    }));
                return;
            }

            // 4. Campos aninhados (produtoBens)
            if (name.startsWith('produtoBens.')) {
                const field = name.replace('produtoBens.', '');

                // campos numericos
                const numberFields = ['frente', 'fundo', 'ladoDireito', 'ladoEsquerdo', 'areaTotal', 'areaConstruida'];

                if (numberFields.includes(field)) {
                    const valorFormatado = formatarNumeroDecimal(v);

                    setDados((prev) => ({
                        ...prev,
                        produtoBens: { ...(prev.produtoBens || {}), [field]: valorFormatado },
                    }));
                    return;
                }

                setDados((prev) => ({
                    ...prev,
                    produtoBens: { ...(prev.produtoBens || {}), [field]: v },
                }));
                return;
            }

            // 5. Fallback raiz
            setDados((prev) => ({ ...prev, [name]: v }));
        },
        [empresaId, setDados, dados.fabricanteId]
    );
    const selectItem = useCallback((item, index, funcao) => {
        setNovoItem({
            ...item,
            funcao,
            index,
            imagens: [], // pendências zeradas
            nfs: [],
        });
        setNCM(item.NCM ?? {});
        setAmbiente(item.Ambiente ?? {});
        setPreviews({ imagens: [], nfs: [] });
    }, []);
    //manutenção das imagens e notas fiscais do inventário
    // Atualiza o estado local do item (novoItem) para refletir mudança imediata
    const patchAnexoLocal = useCallback((kind, uuid, patch) => {
        setNovoItem((prev) => {
            if (!prev) return prev;

            if (kind === 'img') {
                const arr = prev.produtoBensInventarioImagens || [];
                const updated = arr.map((x) => (x.uuid === uuid ? { ...x, ...patch } : x));
                return { ...prev, produtoBensInventarioImagens: updated };
            }

            if (kind === 'pdf') {
                const arr = prev.produtoBensInventarioNFs || [];
                const updated = arr.map((x) => (x.uuid === uuid ? { ...x, ...patch } : x));
                return { ...prev, produtoBensInventarioNFs: updated };
            }

            return prev;
        });
    }, []);

    const editarInventarioImagem = useCallback(
        async ({ uuid, ativo, posicao }) => {
            try {
                const payload = { uuid, ativo, posicao };
                const resp = await ProdutoAPI.editarInventarioBemImagem(payload);

                // se seu API retorna envelope padronizado
                if (resp?.type && resp.type !== 'success') {
                    setFlashMessage?.(resp.message || 'Aviso', resp.type);
                    return;
                }

                // patch local (experiência imediata) + refresh (garantia)
                patchAnexoLocal('img', uuid, { ativo, posicao });
                setFlashMessage?.(resp?.message || 'Imagem atualizada.', resp?.type || 'success');
                await refresh();
            } catch (e) {
                console.error(e);
                setFlashMessage?.('Erro ao editar imagem.', 'error');
            }
        },
        [patchAnexoLocal, refresh, setFlashMessage]
    );

    const editarInventarioPDF = useCallback(
        async ({ uuid, ativo, descricao }) => {
            try {
                const payload = { uuid, ativo };
                if (descricao) payload.descricao = descricao;
                const resp = await ProdutoAPI.editarInventarioBemPDF(payload);

                if (resp?.type && resp.type !== 'success') {
                    setFlashMessage?.(resp.message || 'Aviso', resp.type);
                    return;
                }

                patchAnexoLocal('pdf', uuid, { ativo });
                setFlashMessage?.(resp?.message || 'PDF atualizado.', resp?.type || 'success');
                await refresh();
            } catch (e) {
                console.error(e);
                setFlashMessage?.('Erro ao editar PDF.', 'error');
            }
        },
        [patchAnexoLocal, refresh, setFlashMessage]
    );

    const deletarInventarioImagem = useCallback(
        async ({ uuid, descricao }) => {
            try {
                const payload = { uuid, descricao };
                const resp = await ProdutoAPI.deletarInventarioBemImagem(payload);

                if (resp?.type && resp.type !== 'success') {
                    setFlashMessage?.(resp.message || 'Aviso', resp.type);
                    return;
                }

                // remove local
                setNovoItem((prev) => ({
                    ...prev,
                    produtoBensInventarioImagens: (prev?.produtoBensInventarioImagens || []).filter((x) => x.uuid !== uuid),
                }));

                setFlashMessage?.(resp?.message || 'Imagem removida.', resp?.type || 'success');
                await refresh();
            } catch (e) {
                console.error(e);
                setFlashMessage?.('Erro ao deletar imagem.', 'error');
            }
        },
        [refresh, setFlashMessage]
    );

    const deletarInventarioPdf = useCallback(
        async ({ uuid, descricao }) => {
            try {
                const payload = { uuid, descricao };
                const resp = await ProdutoAPI.deletarInventarioBemPDF(payload);

                if (resp?.type && resp.type !== 'success') {
                    setFlashMessage?.(resp.message || 'Aviso', resp.type);
                    return;
                }

                // remove local
                setNovoItem((prev) => ({
                    ...prev,
                    produtoBensInventarioNFs: (prev?.produtoBensInventarioNFs || []).filter((x) => x.uuid !== uuid),
                }));

                setFlashMessage?.(resp?.message || 'PDF removido.', resp?.type || 'success');
                await refresh();
            } catch (e) {
                console.error(e);
                setFlashMessage?.('Erro ao deletar PDF.', 'error');
            }
        },
        [refresh, setFlashMessage]
    );

    return {
        state: {
            novoItem,
            optionsUF,
            optionsMunicipios,
            OptionsAmbiente,
            Ambiente,
            OptionsNCMInv,
            NCM,
            previews,
            baseItem,
            EnumBemTipo: EnumBemTipoFiltrado,
            EnumPosicao,
            OptionsProprietario,
            Proprietario,
            Modelo,
            OptionsModelo,
            OptionsCores,
            isOnline,
        },
        actions: {
            draft: {
                change,
                handlePBDescricaoFocus,
                handleCepBlur,
                handleDraftFileChange,
                removeDraftAsset,
                clearDraftFiles,
                salvarItem,
                selectItem,
                confirmNcmSelection,
                setNovoItem,
                cleanNovoItem,
            },
            grid: { refresh },
            assets: {
                editarInventarioImagem,
                editarInventarioPDF,
                deletarInventarioImagem,
                deletarInventarioPdf,
                handleImprimirInventario,
                handleReaproveitarArquivoNF,

                /*reaproveitarNFs */
            },
        },
    };
}
